<template>
    <!-- 팝업 -->
    <div class="pop_up_layer" v-show="isShow" @click="fnEvent"></div>
    <div class="pop_up report_banner" v-show="isShow">
        <button class="close_btn icon_wrap" @click="fnEvent">
            <img src="img/close.png" alt="닫기" />
        </button>
        <div class="pop_tit">
            <p v-text="state.title"></p>
        </div>
        <div class="editor_wrap">
            <textarea class="custom_scroll" id="editor1" name="editor1"></textarea>
        </div>
        <div class="btn_wrap _default _center">
            <button class="submit_btn w_120" @click="save">수정</button>
        </div>
    </div>
    <!-- 팝업 -->
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        apiService,
        CkEditorManager,
        getMessageByCode,
        types,
        onMounted,
        onBeforeUnmount,
        onUnmounted,
        reactive,
        ModalDefault,
    } from "@/BaseComponent";

    export default {
        components: { ModalDefault },
        props: {
            isShow: { type: Boolean, default: false },
            type: { type: Number, default: 0 },
            title: { type: String, default: "" },
        },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            let editorManager: CkEditorManager | null = null;

            const state = reactive({
                data: {} as any,
                title: "" as string,

                type: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(async () => {
                if (props.isShow) {
                    document.body.style.overflow = "hidden";
                }

                state.type = props.type;
                state.title = props.title;

                await getDetail();

                editorManager = new CkEditorManager("editor1", { content: state.data.headerTitle });
                await editorManager.initEditor();
            });

            onBeforeUnmount(() => {
                editorManager?.destroy();
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const getDetail = async () => {
                const res = await apiService.report.menuDetail(state.type);

                if (res.returnCode === 0) {
                    state.data = res.data;

                    await editorManager?.setDataInfo(state.data);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const save = async () => {
                state.data = (await editorManager?.getData()) + "";
                const param: types.ReqMenuForModify = {
                    idx: state.type,
                    content: state.data,
                };

                const res = await apiService.report.menuModify(param);
                if (res.returnCode === 0) {
                    fnEvent();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const fnEvent = () => {
                emit("close");
            };

            return { fnEvent, state, save, closeModal };
        },
    };
</script>
